import * as React from 'react';

import type { VStackProps } from '@rtkwlf/fenrir-react';
import { colors, Text, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { Lock } from '../lock/lock';

export const AuthError: React.FC<VStackProps> = ({ ...vProps }) => {
  const { t } = useTranslation();

  return (
    <VStack xAlign="center" padding="large" gap="medium" {...vProps}>
      <Lock
        color={`rgb(${colors.accent.grey.default})`}
        height="50"
        width="auto"
      />
      <Text textAlign="center" style={{ whiteSpace: 'pre-line' }}>
        {t('error:authError.title')}
      </Text>
      <Text textAlign="center" style={{ whiteSpace: 'pre-line' }}>
        {t('error:authError.message')}
      </Text>
    </VStack>
  );
};
